import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VRow,{staticClass:"px-4"},[_c('p',{staticClass:"mr-2"},[_vm._v("Рейтинг заказа:")]),_c('star-rating',{staticClass:"mb-2",attrs:{"rating":_vm.review.rating,"read-only":true,"star-size":20,"show-rating":false,"inactive-color":"#e9e9e9"}})],1),_c('div',{staticClass:"text-sm leading-5 text-gray-500 pesponsive-text"},[_c('span',[_vm._v("Комментарий клиента")]),_c('p',[_vm._v(_vm._s(_vm.review.comment))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }